import React, {  useRef  } from "react";
import Header from "../index/Header";
import Footer from "../index/Footer";


export default function AvisoLegal() {
    const scrollRef = useRef();
  return (
    
    <div className="relative font-cinzel text-eryndra-cream bg-eryndra-forest bg-cover bg-center min-h-screen overflow-hidden">

      <Header scrollRef={scrollRef} backgroundColor="bg-eryndra-forest/20" />
<section class="max-w-4xl mt-4 mx-auto p-6 text-eryndra-cream">
  <h1 class="text-4xl font-cinzel text-eryndra-gold mb-4">Aviso Legal</h1>

  <p class="mb-4 font-bellefair text-xl">En cumplimiento con el deber de información estipulado en la Ley 34/2002 de Servicios de la Sociedad de la Información y el Comercio Electrónico (LSSI-CE), se informa de los siguientes datos:</p>

  <ul class="list-disc list-inside mb-4 font-bellefair text-xl">
    <li><strong>Titular:</strong> Eryndra Eventos</li>
    <li><strong>Correo electrónico de contacto:</strong> info@eryndraeventos.es</li>
    <li><strong>Actividad:</strong> Organización de eventos literarios y de fantasía.</li>
  </ul>

  <p class="mb-4 font-bellefair text-xl">Eryndra Eventos se reserva el derecho de modificar en cualquier momento y sin previo aviso la presentación, configuración y contenido del sitio web, así como las condiciones requeridas para su acceso y/o utilización.</p>

  <h2 class="text-2xl font-bold text-eryndra-gold mb-2">Propiedad Intelectual e Industrial</h2>
  <p class="mb-4 font-bellefair text-xl">Todos los contenidos del sitio web, incluyendo imágenes, textos, logotipos, diseños, marcas y código fuente, están protegidos por la normativa vigente de propiedad intelectual e industrial, y pertenecen a Eryndra Eventos o a terceros que han autorizado su uso. Queda prohibida su reproducción, distribución, transformación o cualquier otra actividad sin autorización expresa del titular.</p>

  <h2 class="text-2xl font-bold text-eryndra-gold mb-2">Responsabilidad</h2>
  <p class="mb-4 font-bellefair text-xl">Eryndra Eventos no se hace responsable de los daños y perjuicios de cualquier naturaleza que puedan derivarse de errores u omisiones en los contenidos, falta de disponibilidad del sitio web o la transmisión de virus o programas maliciosos.</p>

  <h2 class="text-2xl font-bold text-eryndra-gold mb-2">Enlaces</h2>
  <p class="mb-4 font-bellefair text-xl">El sitio puede contener enlaces a sitios web de terceros. Eryndra Eventos no se responsabiliza del contenido de dichas páginas.</p>

  <h2 class="text-2xl font-bold text-eryndra-gold mb-2">Legislación Aplicable</h2>
  <p className="font-bellefair text-xl">Este aviso legal se rige por la legislación española. Para la resolución de conflictos o controversias, las partes se someten a los Juzgados y Tribunales del domicilio del titular del sitio web.</p>
</section>
<Footer />
    </div>

  );
}